// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueResourse from 'vue-resource';
import VueParticles from 'vue-particles'
import VueRouter from 'vue-router';
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

import physics from './views/Research_physics'
import math from './views/Research_math'
import openprojects from './components/openprojects'
import philosophans from './components/philosophans'
import environments from './components/environments'
import Home from './views/Home'
import ThreeDweb from './views/3DWeb'
import philosophy from './views/Reserach_philosophy'
import computational_sciences from './views/Research_computation'
import aerospace from './views/Research_aerospace'
import theology from './views/Research_theology'


import OntologyOfPhysics from './components/ResearchLines/OntologyOfPhysics'
import OntologyOfRelativity from './components/ResearchLines/OntologyOfRelativity'
import Semiotics from './components/ResearchLines/Semiotics'
import Metaphysics from './components/ResearchLines/Metaphysics'
import Gnoseology from './components/ResearchLines/Gnoseology'
import PhilosophyOfMath from './components/ResearchLines/PhilosophyOfMath'

import TheologyOfTrinity from './components/ResearchLines/TheologyOfTrinity'
import CatholicEvolutionism from './components/ResearchLines/CatholicEvolutionism'
import TheologyOfTechnology from './components/Topics/theologyOfTechnology'


import GeneralPhilosophyOfScience from './components/Topics/GeneralPhilosophyOfScience'
import ValueTheory from './components/Topics/valueTheory'
import SocialPoliticalPhilosophy from './components/Topics/socialPoliticalPhilosophy'
import HistoryOfHumanThinking from './components/Topics/historyOfHumanThinking'
import PhilosophyOfArt from './components/Topics/philosophyOfArt'


import ClassificationOfSciences from './components/ResearchLines/ClassificationOfSciences'
import NonNewtonianCalculus from './components/ResearchLines/NonNewtonianCalculus'
import PolynomialLimits from './components/ResearchLines/PolynomialLimitsDevices'
import ExponentialNotation from './components/ResearchLines/ExponentialNotation'
import Topology from './components/Topics/topology'
import NumberTheory from './components/Topics/numberTheory'
import GraphTheory from './components/Topics/graphTheory'
import FractalGeometry from './components/Topics/fractalGeometry'


import NuclearFusion from './components/Topics/nuclearFusion'
import PlanetaryScience from './components/Topics/planetaryScience'
import Cosmology from './components/Topics/cosmology'
import ParticlePhysics from './components/Topics/particlePhysics'
import MultiMessenger from './components/Topics/multiMessenger'
import Astrophysics from './components/Topics/astrophysics'


import MissionManagement from './components/ResearchLines/MissionManagement'
import RocketPropulsionSimulation from './components/ResearchLines/RocketPropulsionSimulation'
import AsteroidMining from './components/ResearchLines/AsteroidMinig'
import JWT from './components/Topics/jwt'
import Parker from './components/Topics/parker'
import Dragonfly from './components/Topics/dragonfly'
import SpaceSuits from './components/Topics/spaceSuits'
import SpaceshipDynamics from './components/Topics/spaceshipDynamics'
import OrbitalMechanics from './components/Topics/orbitalMechanics'
import HistoryOfSpaceExploration from './components/Topics/historyOfSpaceExploration'


import BasicTest from './components/3DProjects/BasicTest'
import Hermeneutics from './components/ResearchLines/Hermeneutics'
import underconstruction from './views/underconstruction'





Vue.config.productionTip = false
Vue.use(VueResourse);
Vue.use(VueParticles);
Vue.use(VueRouter);
//Vue.use(BootstrapVue);

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes:[
  {
    path: '/',
    name: "home",
    component: Home
  },
  {
    path: '/physics',
    component: physics,
    children: [
      {
        path: "/",
        component: OntologyOfRelativity
      },
      {
        path: "/NuclearFusion",
        component: NuclearFusion
      },
      {
        path: "/PlanetaryScience",
        component: PlanetaryScience
      },
      {
        path: "/Cosmology",
        component: Cosmology
      },
      {
        path: "/ParticlePhysics",
        component: ParticlePhysics
      },
      {
        path: "/MultiMessenger",
        component: MultiMessenger
      },
      {
        path: "/Astrophysics",
        component: Astrophysics
      }
    ]
  },
  {
    path: '/mathematics',
    component: math,
    children: [
      {
        path: "/",
        component: NonNewtonianCalculus
      },
      {
        path: "/polynomial_limits",
        component: PolynomialLimits
      },
      {
        path: "/exponential_notation",
        component: ExponentialNotation
      },
      {
        path: "/Topology",
        component: Topology
      },
      {
        path: "/NumberTheory",
        component: NumberTheory
      },
      {
        path: "/GraphTheory",
        component: GraphTheory
      },
      {
        path: "/FractalGeometry",
        component: FractalGeometry
      }
      
    ]
  },
  {
    path: '/aerospace',
    component: aerospace,
    children: [
      {
        path: "/",
        component: AsteroidMining 
      },
      {
        path: "/rocket_propulsion_simulation",
        component: RocketPropulsionSimulation
      },
      {
        path: "/mission_management",
        component: MissionManagement
      },
      {
        path: "/jwt",
        component: JWT
      },
      {
        path: "/parker",
        component: Parker
      },
      {
        path: "/dragonfly",
        component: Dragonfly
      },
      {
        path: "/SpaceSuits",
        component: SpaceSuits
      },
      {
        path: "/SpaceshipDynamics",
        component: SpaceshipDynamics
      },
      {
        path: "/OrbitalMechanics",
        component: OrbitalMechanics
      },
      {
        path: "/HistoryOfSpaceExploration",
        component: HistoryOfSpaceExploration
      }
      
      
    ]
  },
  {
    path: '/computational_science',
    component: computational_sciences
  },
  {
    path: '/theology',
    component: theology,
    children: [
      {
        path: "/Hermeneutics",
        component: Hermeneutics 
      },
      {
        path: "/",
        component: TheologyOfTrinity 
      },
      {
        path: "/TheologyOfTechnology",
        component: TheologyOfTechnology 
      },
      {
        path: "/CatholicEvolutionism",
        component: CatholicEvolutionism 
      }
    ]
  },
  {
    path: '/philosophy',
    component: philosophy,
    children: [{
        path: '/',
        component: OntologyOfPhysics
      },
      {
        path: '/OntologyOfRelativity',
        component: OntologyOfRelativity
      },
      {
        path: '/Semiotics',
        component: Semiotics
      },
      {
        path: '/Philosophy_of_mathematics',
        component: PhilosophyOfMath
      },
      {
        path: '/Classification_of_sciences',
        component: ClassificationOfSciences
      },
      {
        path: '/Metaphysics',
        component: Metaphysics
      },
      {
        path: '/Gnoseology',
        component: Gnoseology
      },
      {
        path: '/GeneralPhilosophyOfScience',
        component: GeneralPhilosophyOfScience
      },
      {
        path: '/ValueTheory',
        component: ValueTheory
      },
      {
        path: '/SocialPoliticalPhilosophy',
        component: SocialPoliticalPhilosophy
      },
      {
        path: '/HistoryOfHumanThinking',
        component: HistoryOfHumanThinking
      },
      {
        path: '/PhilosophyOfArt',
        component: PhilosophyOfArt
      }]
  },
  {
    path: '/3DWeb',
    name: '3DWeb',
    component: ThreeDweb,
    children: [{
      path: '/basic_test',
      component: BasicTest
    }]
  },
  {
    path: '/openprojects',
    component: openprojects
  },
  {
    path: '/philosophans',
    component: philosophans
  },
  {
    path: '/environments',
    component: environments
  },
  {
    path: '/underconstruction',
    component: underconstruction
  }
  ],
  components: {default: 'menu'}
});


/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  components: { App },
  template: '<App/>'
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js